module.exports = __webpack_public_path__ + "media/summer_2023_sweepstakes/twitter-cd4add3f.svg";